<div class="row mb-3" *transloco="let t">
  <div *ngIf="visible" class="col-xl-4 col-lg-7 col-md-1">
    <button class="btn btn-outline-primary min-width-100 text-nowrap" [disabled]="disabled" (click)="upload()">
      <i class="ri-upload-line"></i> {{ t("bulkLinks.uploadBtn") }}
    </button>
  </div>
</div>
